import styled from 'styled-components';

const classPrefix = 'ui-form-section';
const headerPrefix = `${classPrefix}-header`;

export const sectionClasses = {
  wrapper: classPrefix,
  header: headerPrefix,
  title: `${headerPrefix}-title`,
  description: `${headerPrefix}-description`,
  extra: `${headerPrefix}-extra`,
} as const;

export const FormSectionSC = styled.fieldset`
  width: 100%;

  .${sectionClasses.header} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .${sectionClasses.description} {
    color: ${({ theme }) => theme.color.tint.secondary};
  }

  &.${`${sectionClasses.wrapper}-large`} {
    margin-top: 32px;

    .${sectionClasses.title} {
      padding-bottom: 16px;
    }

    &.${`${sectionClasses.wrapper}-description`} {
      .${sectionClasses.title} {
        padding-bottom: 0px;
      }
    }

    .${sectionClasses.description} {
      padding-bottom: 16px;
    }
  }

  &.${`${sectionClasses.wrapper}-small`} {
    margin-top: 8px;

    .${sectionClasses.title} {
      padding-bottom: 8px;
    }

    &.${`${sectionClasses.wrapper}-description`} {
      .${sectionClasses.title} {
        padding-bottom: 0px;
      }
    }

    .${sectionClasses.description} {
      padding-bottom: 8px;
    }
  }
`;
